// Weitere Briefköpfe der Quittung je Mandant (Kundenwunsch 20.10.2026): Im Mandanten 10 (Mückenhausen) fährt auch
// Artmeier. Vor dem Druck wählt man deshalb, wessen Firmendaten oben auf der Quittung stehen. Der erste Briefkopf ist
// immer der des Mandanten (Einstellungen → Kundendaten, Logo „briefkopf.png“), die weiteren stehen hier fest. Ihr Logo
// lädt der Kunde unter Stammdaten → Logo mit dem angegebenen Dateinamen hoch; ohne Logo steht der Name als Schriftzug
// im Kopf. Mandanten ohne Eintrag drucken ohne Auswahl wie bisher.
const EXTRA_LETTERHEADS = {
  10: [
    {
      key: 'artmeier',
      // Daten aus dem Impressum von artmeier-bus.de
      letterhead: { name: 'Artmeier Bus GmbH & Co. KG', url: 'artmeier-bus.de', tel: '+49 991 991 3411 0' },
      logo: /^briefkopf-artmeier\.(png|jpe?g)$/i
    }
  ]
};

export function extraLetterheads(customerId) {
  return EXTRA_LETTERHEADS[Number(customerId)] || [];
}
